import axios from 'axios'
import { API_BASE } from '../config'

function authHeaders() {
    let token = localStorage.getItem('token');
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

export default class Admin {
    // GET /admin/access - What the viewer may do: { allowed, staff, open }. allowed is whether they may use the
    // admin panel; staff is whether they are logged in as Staff or above.
    getAccess() {
        return axios.get(`${API_BASE}/admin/access`, authHeaders()).then(x => x.data);
    }

    // GET /admin/users - Everyone who has signed up:
    // { open, viewerID, viewerLevel, levels: [{ id, name }] (lowest first), badges: [{ id, name, color }], canBadge,
    //   badgeLimits: { nameMaxLength, most, defaultColor },
    //   users: [{ id, username, level, joined, lastLogin, lastSeen, online, canSet, canDelete, badges }] } where canSet
    // lists the levels the viewer may set that user to, canDelete says whether they may delete that user's account,
    // and online whether that user is on the site or in a game right now. badges lists the site's badges
    // (color is "#rrggbb"), each user's badges the ids of the ones they have, and canBadge whether the viewer may
    // manage them; badgeLimits is what a new badge may be.
    getUsers() {
        return axios.get(`${API_BASE}/admin/users`, authHeaders()).then(x => x.data);
    }

    // GET /admin/users/:id - One user in full: { user, limits: { usernameMinLength, usernameMaxLength, bioMaxLength } }
    // where user is as in the list, with { bio, signIn: { password, google }, coins: { have, earned },
    // cards: { different, copies, packs }, achievements: [{ game, name, earned, total }], canEdit }
    getUser(userID) {
        return axios.get(`${API_BASE}/admin/users/${encodeURIComponent(userID)}`, authHeaders()).then(x => x.data);
    }

    // PUT /admin/users/:id/profile - Change a user's username or biography, from any of { username, bio }:
    // { success, user } as getUser gives them. A refusal's response names the field it is about: { field, message }
    editUser(userID, changes) {
        return axios.put(`${API_BASE}/admin/users/${encodeURIComponent(userID)}/profile`, changes, authHeaders()).then(x => x.data);
    }

    // DELETE /admin/users/:id - Delete a user's account for good: { success }
    deleteUser(userID) {
        return axios.delete(`${API_BASE}/admin/users/${encodeURIComponent(userID)}`, authHeaders()).then(x => x.data);
    }

    // POST /admin/badges - Add a badge to the site: { success, badge, badges } where badges is every badge it now
    // has. A refusal's response names the field it is about: { field, message }
    addBadge(name, color) {
        return axios.post(`${API_BASE}/admin/badges`, { name, color }, authHeaders()).then(x => x.data);
    }

    // PUT /admin/badges/:badge - Change the colour a badge is drawn in: { success, badges }
    setBadgeColor(badgeID, color) {
        return axios.put(`${API_BASE}/admin/badges/${encodeURIComponent(badgeID)}`, { color }, authHeaders()).then(x => x.data);
    }

    // DELETE /admin/badges/:badge - Remove a badge from the site, and from everyone who has it: { success, badges }
    deleteBadge(badgeID) {
        return axios.delete(`${API_BASE}/admin/badges/${encodeURIComponent(badgeID)}`, authHeaders()).then(x => x.data);
    }

    // PUT /admin/users/:id/badges/:badge - Give a user a badge, or (with has false) take it away: { success, user }
    setBadge(userID, badgeID, has) {
        return axios.put(`${API_BASE}/admin/users/${encodeURIComponent(userID)}/badges/${encodeURIComponent(badgeID)}`, { has }, authHeaders()).then(x => x.data);
    }

    // PUT /admin/users/:id/level - Set a user's access level: { success, user }
    setLevel(userID, level) {
        return axios.put(`${API_BASE}/admin/users/${encodeURIComponent(userID)}/level`, { level }, authHeaders()).then(x => x.data);
    }
}
